module.exports = __webpack_public_path__ + "static/media/sheet_music_tile.ad92f8d1.jpg";